<template>
  <div class="bg-white text-dark-type-3 rounded-lg pt-4 pb-2 booking-details" >
    <div class="flex p-4 pb-6">
      <div class="pt-2">
        <template v-if="returnTrip">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4C0 1.79086 1.79086 0 4 0Z" fill="#F3F7F5"/>
            <circle cx="17" cy="16" r="10" fill="white" fill-opacity="0.01"/>
            <path d="M22.3335 15.9999H10.6668" stroke="#C7D1CC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14.8335 11.8333L10.6668 15.9999L14.8335 20.1666" stroke="#C7D1CC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </template>

        <template v-else>
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4C0 1.79086 1.79086 0 4 0Z" fill="#F3F7F5"/>
            <circle cx="17" cy="16" r="10" fill="white" fill-opacity="0.01"/>
            <path d="M10.3335 15.9999H22.0002" stroke="#C7D1CC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M17.8335 11.8333L22.0002 15.9999L17.8335 20.1666" stroke="#C7D1CC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </template>
      </div>
      <div class="w-100">
        <div class="flex justify-between px-4">

          <div>
            <label class="font-bold text-xs text-dark-type-3 leading-5">{{returnTrip ? 'Return Trip' : 'Outbound trip'}}</label>
            <p class="text-xs text-dark-type-3">{{ routeDetails.start_date | date('ddd, MMM DD YYYY') }}</p>
          </div>
          <div class="flex items-center">
            <div>
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4C0 1.79086 1.79086 0 4 0Z" fill="#F3F7F5"/>
                <path d="M9.62021 15.129V13.1847C9.79909 13.1847 9.94427 13.0395 9.94427 12.8607C9.94427 12.6818 9.79909 12.5366 9.62021 12.5366C8.72652 12.5366 8 13.2638 8 14.1569V14.8049C8 15.3409 8.43615 15.7771 8.97213 15.7771H9.62021C9.79909 15.7771 9.94427 15.6319 9.94427 15.453C9.94427 15.2742 9.79909 15.129 9.62021 15.129Z" fill="#C7D1CC"/>
                <path d="M21.9339 12.5366C21.755 12.5366 21.6099 12.6818 21.6099 12.8607C21.6099 13.0395 21.755 13.1847 21.9339 13.1847V15.129C21.755 15.129 21.6099 15.2742 21.6099 15.4531C21.6099 15.6319 21.755 15.7771 21.9339 15.7771H22.582C23.118 15.7771 23.5541 15.3409 23.5541 14.8049V14.1569C23.5541 13.2638 22.8276 12.5366 21.9339 12.5366Z" fill="#C7D1CC"/>
                <path d="M13.5087 21.6099C13.3298 21.6099 13.1847 21.755 13.1847 21.9339H11.2404C11.2404 21.755 11.0952 21.6099 10.9163 21.6099C10.7375 21.6099 10.5923 21.755 10.5923 21.9339V22.582C10.5923 23.118 11.0284 23.5541 11.5644 23.5541H12.8606C13.3966 23.5541 13.8328 23.118 13.8328 22.582V21.9339C13.8328 21.755 13.6876 21.6099 13.5087 21.6099Z" fill="#C7D1CC"/>
                <path d="M20.6376 21.6099C20.4587 21.6099 20.3135 21.755 20.3135 21.9339H18.3693C18.3693 21.755 18.2241 21.6099 18.0452 21.6099C17.8663 21.6099 17.7212 21.755 17.7212 21.9339V22.582C17.7212 23.118 18.1573 23.5541 18.6933 23.5541H19.9895C20.5255 23.5541 20.9616 23.118 20.9616 22.582V21.9339C20.9616 21.755 20.8165 21.6099 20.6376 21.6099Z" fill="#C7D1CC"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.6379 8H10.9166C10.0229 8 9.29639 8.72716 9.29639 9.62021V20.6377C9.29639 21.5308 10.0229 22.258 10.9166 22.258H20.6379C21.5317 22.258 22.2582 21.5308 22.2582 20.6377V9.62021C22.2582 8.72716 21.5317 8 20.6379 8ZM12.2128 9.29619H19.3418C19.8778 9.29619 20.3139 9.73234 20.3139 10.2683C20.3139 10.8043 19.8778 11.2405 19.3418 11.2405H12.2128C11.6768 11.2405 11.2407 10.8043 11.2407 10.2683C11.2407 9.73234 11.6768 9.29619 12.2128 9.29619ZM11.2407 19.3416C11.2407 19.8775 11.6768 20.3137 12.2128 20.3137C12.7487 20.3137 13.1849 19.8775 13.1849 19.3416C13.1849 18.8056 12.7488 18.3694 12.2128 18.3694C11.6768 18.3694 11.2407 18.8056 11.2407 19.3416ZM19.3418 20.3137C18.8058 20.3137 18.3696 19.8775 18.3696 19.3416C18.3696 18.8056 18.8058 18.3694 19.3418 18.3694C19.8777 18.3694 20.3139 18.8056 20.3139 19.3416C20.3139 19.8775 19.8777 20.3137 19.3418 20.3137ZM19.9901 17.0732C20.5261 17.0732 20.9622 16.637 20.9622 16.101H20.9622V12.8606C20.9622 12.3246 20.526 11.8884 19.9901 11.8884H11.5649C11.0289 11.8884 10.5928 12.3246 10.5928 12.8606V16.101C10.5928 16.637 11.0289 17.0732 11.5649 17.0732H19.9901Z" fill="#C7D1CC"/>
              </svg>
            </div>
            <span class="font-bold text-sm text-dark-type-3 leading-5 ml-1 text-right">Bus {{routeDetails.route.route_code}}</span>
          </div>
        </div>
        <div class="flex justify-between px-4 mt-4">
          <div class="mx-30">
            <p class="font-bold leading-normal">{{routeDetails.itinerary.departure_time}}<span class="lowercase"> {{ routeDetails.itinerary.time_of_day }}</span></p>
            <p class="text-dark-type-4 text-xs">{{routeDetails.pickupRouteBusStop.name}}</p>
          </div>
          <div class="mx-30" style="align-self: center">
            <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.3335 5.99992H13.0002" stroke="#737D78" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.8335 1.83325L13.0002 5.99992L8.8335 10.1666" stroke="#737D78" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="mx-30">
            <p class="font-bold leading-normal">{{arrivalTimeFormatted}}</p>
            <p class="text-dark-type-4 text-xs">{{routeDetails.destinationRouteBusStop.name}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="p-4 border-gray-100 border-t border-solid">
      <p class="flex justify-between align-center"><span class="text-xxs font-medium leading-3">Route Name</span> <span class="text-right text-xxs text-gray-500" style="max-width: 50%">{{routeDetails.route.name}}</span></p>
      <p class="flex justify-between align-center mt-6"><span class="text-xxs font-medium leading-3">Route Code</span> <span class="text-right text-xxs text-gray-500" style="max-width: 50%">{{routeDetails.route.route_code}}</span></p>
    </div>

    <div class="p-4 border-gray-100 border-t border-solid flex justify-between items-center">
      <div class="flex">
        <div class="px-4 relative flex items-center">
          <img :src="routeDetails.driver.avatar || require('@/assets/img/user_avatar.svg')" class="driver-image">
          <div class="ml-4">
            <svg width="31" height="33" viewBox="0 0 31 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.99485 3.72021H0V11.4684H1.99485V3.72021Z" fill="black"/>
              <path d="M5.78493 15.5098H0.691406V7.58765H1.28986V14.9076H5.78493V15.5098Z" fill="black"/>
              <path d="M29.0012 11.4578L30.9961 11.4578L30.9961 3.70959L29.0012 3.70959L29.0012 11.4578Z" fill="black"/>
              <path d="M30.3084 15.5098H25.2148V14.9076H29.7099V7.58765H30.3084V15.5098Z" fill="black"/>
              <path d="M9.03003 33H6.7559C5.85156 33 5.12012 32.264 5.12012 31.354V25.9209C5.12012 25.0109 5.85156 24.2749 6.7559 24.2749H9.03003C9.93436 24.2749 10.6658 25.0109 10.6658 25.9209V31.354C10.6658 32.264 9.93436 33 9.03003 33Z" fill="#001C2B"/>
              <path d="M24.2839 33H22.0098C21.1055 33 20.374 32.264 20.374 31.354V25.9209C20.374 25.0109 21.1055 24.2749 22.0098 24.2749H24.2839C25.1883 24.2749 25.9197 25.0109 25.9197 25.9209V31.354C25.9197 32.264 25.1883 33 24.2839 33Z" fill="#001C2B"/>
              <path d="M28.2205 11.4685H2.75293V28.825H28.2205V11.4685Z" fill="#20E682"/>
              <path d="M28.2205 3.55961V18.2664H2.75293V3.55961C2.75293 1.59246 4.33551 0 6.29047 0H24.683C26.638 0 28.2205 1.59246 28.2205 3.55961Z" fill="black"/>
              <path opacity="0.1" d="M28.2203 3.55961V18.2664H15.4932V0H24.6961C26.6377 0 28.2203 1.59246 28.2203 3.55961Z" fill="white"/>
              <path d="M10.0807 26.2286H2.75293V23.4719L9.28275 24.2347C9.73492 24.2882 10.0807 24.7432 10.0807 25.2919V26.2286Z" fill="black"/>
              <path opacity="0.2" d="M28.2203 18.2664H15.4932V28.8248H28.2203V18.2664Z" fill="#FDFFFE"/>
              <path d="M20.8926 26.2286H28.2203V23.4719L21.6905 24.2347C21.2384 24.2882 20.8926 24.7432 20.8926 25.2919V26.2286Z" fill="black"/>
            </svg>
          </div>
        </div>
        <div class="ml-2">
          <p class="text-xs font-medium leading-3">{{routeDetails.driver.fname}} {{routeDetails.driver.lname}}</p>
          <p class="text-xs text-gray-500 leading-3 mt-2">{{routeDetails.vehicleData.registration_number}}</p>
        </div>
      </div>

      <a href="tel:0700 070 0080" class="cursor-pointer decoration-none">
        <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="23" cy="23" r="23" fill="#EFF2F7"/>
          <path d="M17.1107 14.152C17.4332 14.0514 17.7677 14 18.1046 14C19.7236 14 20.9231 15.4257 20.9231 17.0379L20.9231 20.6544C20.9231 22.2667 19.7236 23.6923 18.1046 23.6923C17.7677 23.6923 17.4332 23.641 17.1107 23.5403L16.8642 23.4633C16.78 23.437 16.6972 23.4079 16.6158 23.376C17.9001 25.9841 20.0159 28.0999 22.624 29.3842C22.5921 29.3028 22.563 29.22 22.5367 29.1358L22.4597 28.8893C22.359 28.5668 22.3077 28.2323 22.3077 27.8954C22.3077 26.2764 23.7333 25.0769 25.3456 25.0769H28.9621C30.5743 25.0769 32 26.2764 32 27.8954C32 28.2323 31.9486 28.5668 31.8479 28.8893L31.771 29.1358C31.3226 30.5717 30.0401 31.6116 28.506 31.882C27.6128 32.0393 26.6949 32.0394 25.8017 31.882C25.7665 31.8758 25.7315 31.8692 25.6966 31.8622C19.8428 30.7359 15.264 26.1571 14.1378 20.3033C14.1308 20.2684 14.1242 20.2334 14.118 20.1983C13.9607 19.3051 13.9607 18.3872 14.118 17.494C14.3884 15.9599 15.4283 14.6774 16.8642 14.229L17.1107 14.152Z" fill="#000005"/>
          <path d="M24.1128 15.5911C25.8866 15.0857 27.8181 15.5085 29.1548 16.8452C30.4916 18.1819 30.9143 20.1135 30.4089 21.8872C30.3041 22.255 30.5173 22.638 30.885 22.7428C31.2527 22.8475 31.6357 22.6344 31.7405 22.2667C32.3727 20.0478 31.8531 17.5853 30.1339 15.8661C28.4147 14.1469 25.9523 13.6273 23.7334 14.2595C23.3656 14.3643 23.1525 14.7473 23.2573 15.115C23.362 15.4827 23.7451 15.6959 24.1128 15.5911Z" fill="#000005"/>
          <path d="M25.8462 18.1074C26.3133 18.0143 26.905 18.1712 27.3669 18.6331C27.8288 19.095 27.9857 19.6867 27.8927 20.1538C27.818 20.5288 28.0614 20.8933 28.4364 20.968C28.8114 21.0427 29.1759 20.7993 29.2506 20.4243C29.4416 19.4654 29.1065 18.4145 28.346 17.654C27.5855 16.8935 26.5347 16.5584 25.5757 16.7494C25.2008 16.8241 24.9573 17.1886 25.032 17.5636C25.1067 17.9386 25.4712 18.1821 25.8462 18.1074Z" fill="#000005"/>
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "BookingSummary",
  props: {
    routeDetails: {type: Object, required: true},
    returnTrip: {type: Boolean, default: false}
  },
  computed: {
    arrivalTimeFormatted() {
      const route_duration = this.routeDetails.route.duration;
      const {departure_time, time_of_day} = this.routeDetails.itinerary;
      let durationParts = route_duration.split(" ");
      let duration = parseInt(durationParts[0]);
      if (durationParts[1] === "hour") {
        duration = duration * 60;
      }
      return moment(`${departure_time} ${time_of_day}`, "h:mm A")
          .add(duration, "m")
          .format("h:mm a");
    }
  }
}
</script>

<style lang="scss" scoped>
.mx-30 {
  max-width: 33%;
}

.booking-details {
  position: relative;

  &:not(:first-of-type) {
    background-image: linear-gradient(to right, theme('colors.gray.type-7') 33%, rgba(255,255,255,0) 0%);
    background-size: 1.25rem 1px;
    background-repeat: repeat-x;
    border-radius: 0 0 0.5rem 0.5rem;

    &:before, &:after {
      content:" ";
      position:absolute;
      width:24px;
      height:24px;
      border-radius:50%;
      @apply bg-gray-type-5;
    }

    &:before {
      box-shadow: inset -3px 0px 4px -2px rgb(0 0 0 / 8%);
      left: -12px;
      top: -12px;
    }

    &:after {
      box-shadow: inset 3px 0px 4px -2px rgb(0 0 0 / 8%);
      right: -12px;
      top: -12px;
    }
  }
  &:not(:last-of-type) {
    border-radius: 0.5rem 0.5rem 0 0;
  }

  & .driver-image {
    height: 2.5rem;
    width: 2.5rem;
    border-radius: 50%;
    position: absolute;
    left: 0;
  }

  .w-100 {
    width: 100%;
  }
}
</style>